// extracted by mini-css-extract-plugin
module.exports = {"values":"styles_values__YUN6b","card":"styles_card__9BalW","pulse":"styles_pulse__Rc9so","jump":"styles_jump__SFGIs","wiggle":"styles_wiggle__Px0Jd"};